import { useState, useCallback } from 'react';

import {
  ImportReviewState,
  INITIAL_IMPORT_REVIEW,
} from './import-review-types';

export function useImportReviewState() {
  const [importReview, setImportReview] = useState<ImportReviewState>(
    INITIAL_IMPORT_REVIEW,
  );

  const resetImportReview = useCallback(() => {
    setImportReview(INITIAL_IMPORT_REVIEW);
  }, []);

  const setVlanSubnetConfirmed = useCallback((value: boolean) => {
    setImportReview((r) => ({ ...r, vlanSubnetConfirmed: value }));
  }, []);

  const setGlobalSettingsConfirmed = useCallback((value: boolean) => {
    setImportReview((r) => ({ ...r, globalSettingsConfirmed: value }));
  }, []);

  const setNodeReviewed = useCallback(
    (nodeIds: string[], reviewed: boolean) => {
      setImportReview((r) => ({
        ...r,
        nodeReviewed: {
          ...r.nodeReviewed,
          ...Object.fromEntries(nodeIds.map((id) => [id, reviewed])),
        },
      }));
    },
    [],
  );

  const setEdgeReviewed = useCallback(
    (edgeIds: string[], reviewed: boolean) => {
      setImportReview((r) => ({
        ...r,
        edgeReviewed: {
          ...r.edgeReviewed,
          ...Object.fromEntries(edgeIds.map((id) => [id, reviewed])),
        },
      }));
    },
    [],
  );

  const clearNodeReview = useCallback((nodeIds: string[]) => {
    setImportReview((r) => ({
      ...r,
      nodeReviewed: {
        ...r.nodeReviewed,
        ...Object.fromEntries(nodeIds.map((id) => [id, false])),
      },
    }));
  }, []);

  const clearEdgeReview = useCallback((edgeIds: string[]) => {
    setImportReview((r) => ({
      ...r,
      edgeReviewed: {
        ...r.edgeReviewed,
        ...Object.fromEntries(edgeIds.map((id) => [id, false])),
      },
    }));
  }, []);
  return {
    importReview,
    resetImportReview,
    setVlanSubnetConfirmed,
    setGlobalSettingsConfirmed,
    setNodeReviewed,
    setEdgeReviewed,
    clearNodeReview,
    clearEdgeReview,
  };
}
